import { PERMISSIONS } from '@savgroup-front-common/constants';
import { useHasPermission } from '@savgroup-front-common/core/hooks';

const useHasSellerApplicationPermission = (): boolean => {
  return useHasPermission(PERMISSIONS.API_USERS_MANAGEMENT);
};

export default useHasSellerApplicationPermission;
